<template>
  <div class="seat-color-picker">
    <p class="seat-color-picker__label">{{ workflowLabel(label) }} {{ adminText('workflowsAll.color_6dd0fe8', 'color') }}</p>
    <div class="seat-color-picker__colors">
      <button
        v-for="color in visibleColors"
        :key="color"
        type="button"
        class="seat-color-picker__color"
        :class="{ 'seat-color-picker__color--selected': color === value }"
        :aria-label="workflowLabel((adminText('workflowsAll.select_0caa404', 'Select ') + (label.toLowerCase()) + adminText('workflowsAll.color_8a59990', ' color ') + (color) + ''))"
        :aria-pressed="color === value"
        @click="$emit('input', color)"
      >
        <span class="seat-color-picker__swatch" :style="{ backgroundColor: color }" />
        <v-icon v-if="color === value" class="seat-color-picker__check" size="12">done</v-icon>
      </button>
      <button
        type="button"
        class="seat-color-picker__toggle"
        :aria-label="workflowLabel(isExpanded ? adminText('workflowsAll.show_fewer_seat_colors_e0ec1a6', 'Show fewer seat colors') : adminText('workflowsAll.show_all_seat_colors_a7f17c8', 'Show all seat colors'))"
        :aria-expanded="isExpanded.toString()"
        @click="isExpanded = !isExpanded"
      >
        <v-icon size="24">{{ isExpanded ? 'expand_less' : 'expand_more' }}</v-icon>
      </button>
    </div>
  </div>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
const COLLAPSED_COLORS = ['#C76A00', '#B39700', '#69B500', '#00A8C0', '#0079DC', '#5308B6', '#A70796']

// This is the complete colour range from the floor-plan ticket design. The first row is the
// compact picker shown by default; opening it exposes the complete selection.
const FLOOR_PLAN_SEAT_COLORS = [
  '#C76A00',
  '#C37300',
  '#BF7C00',
  '#BB8500',
  '#B78E00',
  '#B39700',
  '#AFA000',
  '#A0A600',
  '#8EAB00',
  '#7CB000',
  '#69B500',
  '#54B800',
  '#3FBA00',
  '#28BB10',
  '#10BC2A',
  '#00BC46',
  '#00BB63',
  '#00B87F',
  '#00B49A',
  '#00AFB3',
  '#00A8C0',
  '#009FCA',
  '#0094D2',
  '#0087D8',
  '#0079DC',
  '#0069DE',
  '#0058DE',
  '#0046DC',
  '#0034D7',
  '#0023D1',
  '#1415CB',
  '#2A10C4',
  '#3F0CBD',
  '#5308B6',
  '#6606AF',
  '#7805A8',
  '#8905A1',
  '#99069B',
  '#A70796',
  '#B40892',
]

export { COLLAPSED_COLORS, FLOOR_PLAN_SEAT_COLORS }

export default {
  mixins: [WorkflowDisplay],
  name: 'floor-plan-seat-color-picker',
  props: {
    value: {
      type: String,
      default: COLLAPSED_COLORS[0],
    },
    label: {
      type: String,
      default: 'Seat',
    },
  },
  data: () => ({
    isExpanded: false,
  }),
  computed: {
    visibleColors() {
      return this.isExpanded ? FLOOR_PLAN_SEAT_COLORS : COLLAPSED_COLORS
    },
  },
}
</script>

<style scoped>
.seat-color-picker {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 16px;
}

.seat-color-picker__label {
  margin: 0;
  color: #333333;
  font-family: 'Source Sans Pro';
  font-size: 18px;
  font-weight: 400;
  line-height: 1.2;
}

.seat-color-picker__colors {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  max-width: 800px;
}

.seat-color-picker__color,
.seat-color-picker__toggle {
  position: relative;
  display: flex;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border: 1.5px solid transparent;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
}

.seat-color-picker__color--selected {
  border-color: #d9d9d9;
}

.seat-color-picker__color:focus-visible,
.seat-color-picker__toggle:focus-visible {
  outline: 2px solid #0277bd;
  outline-offset: 2px;
}

.seat-color-picker__swatch {
  display: block;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.08);
}

.seat-color-picker__check {
  position: absolute;
  color: #ffffff;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.35);
}

.seat-color-picker__toggle {
  width: 24px;
  height: 24px;
  margin: 8px;
  padding: 0;
  color: #666666;
}

@media (max-width: 840px) {
  .seat-color-picker__colors {
    max-width: 100%;
  }
}
</style>
